export const BO_CSS = `
.bo{--ink:#232047;--mut:#67648F;--line:#E4E3F0;--soft:#F7F7FC;position:relative;overflow:hidden;border-radius:18px;background:#fff;box-shadow:0 40px 80px -40px rgba(24,19,67,.38),0 0 0 1px var(--line);text-align:left;font-size:13px;color:var(--ink)}
.bo button{font:inherit;color:inherit;background:none;border:0;cursor:pointer}
.bo .bo-top{display:flex;align-items:center;gap:10px;padding:12px 18px;border-bottom:1px solid var(--line);background:#FBFBFE}
.bo .bo-mono{display:grid;place-items:center;width:24px;height:24px;border-radius:7px;background:var(--bo-acc);color:#fff;font-weight:700;font-size:12px}
.bo .bo-brand{font-weight:700;color:#241E61;font-size:13.5px}
.bo .bo-scope{margin-left:6px;padding:4px 10px;border-radius:999px;background:#fff;box-shadow:inset 0 0 0 1px var(--line);font-size:11.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.bo .bo-scope-k{color:var(--mut)}
.bo .bo-range{margin-left:auto;font-size:11.5px;color:var(--mut);white-space:nowrap}
.bo .bo-body{display:grid;grid-template-columns:minmax(0,1fr)}
.bo .bo-rail{position:relative;display:flex;gap:6px;overflow-x:auto;padding:10px 12px;border-bottom:1px solid var(--line);scrollbar-width:none}
.bo .bo-rail::-webkit-scrollbar{display:none}
.bo .bo-tab{position:relative;flex:none;display:grid;grid-template-columns:auto 1fr;column-gap:8px;align-items:baseline;padding:8px 12px;border-radius:10px;text-align:left;overflow:hidden;color:var(--mut)}
.bo .bo-tab:hover{background:var(--soft)}
.bo .bo-tab.is-on{background:#ECEBF7;color:#241E61}
.bo .bo-tab-n{font-size:10.5px;opacity:.7}
.bo .bo-tab-q{font-weight:600;font-size:12.5px;white-space:nowrap}
.bo .bo-tab-l{display:none}
.bo .bo-tab-fill{position:absolute;left:0;bottom:0;height:2px;width:100%;transform-origin:left;transform:scaleX(0);background:linear-gradient(95deg,#3FAE6C,#8FD53A 55%,#CFF710);animation:bo-fill linear forwards}
@keyframes bo-fill{to{transform:scaleX(1)}}
.bo .bo-rail-note{display:none}
.bo .bo-canvas{padding:16px 14px 18px;background:var(--soft);min-width:0}
.bo .bo-canvas-h{display:flex;align-items:center;gap:10px;margin:2px 2px 12px}
.bo .bo-canvas-h h3{margin:0;font-size:17px;font-weight:700;letter-spacing:-.015em;color:#241E61}
.bo .bo-view{animation:bo-in .42s cubic-bezier(.215,.61,.355,1) both}
@keyframes bo-in{from{opacity:0;transform:translateY(8px)}}
.bo .bo-grid{display:grid;gap:10px;grid-template-columns:repeat(2,minmax(0,1fr))}
.bo .bo-grid > *{grid-column:1/-1}
.bo .bo-grid > .bo-kpi{grid-column:auto}
.bo .bo-grid-owners > .ga-c,.bo .bo-grid-breaks > .ga-c,.bo .bo-grid-earns > .ga-c{display:none}
.bo .bo-grid-asks > .ga-t{order:3}.bo .bo-grid-asks > .ga-r{order:4}
.bo .bo-opt{display:none}
.bo .bo-tile{background:#fff;border-radius:12px;padding:12px 14px;box-shadow:0 0 0 1px var(--line),0 1px 2px rgba(24,19,67,.04);min-width:0}
.bo .bo-tile-h{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:10px;font-size:11.5px;font-weight:600;color:var(--mut)}
.bo .bo-kpi{display:flex;flex-direction:column;gap:2px}
.bo .bo-k{font-size:11.5px;color:var(--mut);font-weight:500}
.bo .bo-v{font-size:24px;font-weight:700;letter-spacing:-.03em;color:#241E61;line-height:1.15;font-variant-numeric:tabular-nums}
.bo .bo-d{font-size:11px;color:var(--mut)}
.bo .bo-d.is-up{color:#23794A}
.bo .bo-d.is-warn{color:#8A5A12}
.bo .bo-bars{display:flex;align-items:flex-end;gap:5px;height:96px}
.bo .bo-bars i{flex:1;border-radius:4px 4px 2px 2px;background:#D9D7EE;transform-origin:bottom;animation:bo-grow .6s cubic-bezier(.215,.61,.355,1) both}
.bo .bo-bars i.is-now{background:#2F9E58}
@keyframes bo-grow{from{transform:scaleY(.08)}}
.bo .bo-area{display:block;width:100%;height:96px;overflow:visible}
.bo .bo-area-line{stroke-dasharray:600;stroke-dashoffset:600;animation:bo-draw 1s .1s cubic-bezier(.215,.61,.355,1) forwards}
@keyframes bo-draw{to{stroke-dashoffset:0}}
.bo .bo-split{display:flex;gap:2px;height:12px;border-radius:6px;overflow:hidden}
.bo .bo-split i{display:block;min-width:3px}
.bo .bo-legend{list-style:none;margin:10px 0 0;padding:0;display:grid;gap:4px;font-size:11.5px}
.bo .bo-legend li{display:flex;align-items:center;gap:7px}
.bo .bo-legend li span{width:8px;height:8px;border-radius:2px}
.bo .bo-legend b{margin-left:auto;font-weight:600;font-variant-numeric:tabular-nums}
.bo .bo-queue{display:flex;align-items:center;gap:10px;font-size:12.5px;font-weight:500}
.bo .bo-queue-dot{width:8px;height:8px;border-radius:50%;background:#E0A33A;box-shadow:0 0 0 4px #FDF1DE;flex:none}
.bo .bo-queue-go{margin-left:auto;display:inline-flex;align-items:center;gap:4px;color:#241E61;font-weight:600;white-space:nowrap}
.bo .bo-topics{list-style:none;margin:0;padding:0}
.bo .bo-topics li{display:grid;grid-template-columns:minmax(0,1fr) auto;column-gap:10px;padding:8px 0;border-top:1px solid #EEEDF5}
.bo .bo-topics li:first-child{border-top:0;padding-top:0}
.bo .bo-topic-t{font-weight:600;font-size:12.5px}
.bo .bo-topic-n{display:inline-flex;align-items:center;gap:5px;font-weight:600;font-variant-numeric:tabular-nums}
.bo .bo-topic-s{grid-column:1/-1;font-size:11px;color:var(--mut)}
.bo .bo-topics li.is-flag .bo-topic-s{color:#8A5A12;font-weight:500}
.bo .bo-trend{fill:none;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}
.bo .bo-trend.is-up{stroke:#2F9E58}.bo .bo-trend.is-down{stroke:#8E8BB5}.bo .bo-trend.is-flat{stroke:#B9B6D9}
.bo .bo-topics li.is-flag .bo-trend{stroke:#C9831A}
.bo .bo-reco,.bo .bo-bulletin{display:flex;flex-direction:column;gap:8px}
.bo .bo-reco{background:#241E61;color:#fff;box-shadow:none}
.bo .bo-reco-k{font-size:10.5px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--mut)}
.bo .bo-reco .bo-reco-k{color:#CFF710}
.bo .bo-reco p{margin:0;font-size:13.5px;line-height:1.45;color:rgba(255,255,255,.88)}
.bo .bo-reco p b{color:#fff}
.bo .bo-btn{align-self:flex-start;margin-top:2px;padding:8px 14px;border-radius:999px;font-weight:600;font-size:12px;background:#fff !important;color:#241E61 !important;transition:background .2s}
.bo .bo-btn.is-done{background:#E7F5EC !important;color:#23794A !important;cursor:default}
.bo .bo-btn-dark{background:#241E61 !important;color:#fff !important}
.bo .bo-pill{padding:3px 8px;border-radius:999px;font-size:10.5px;font-weight:600;white-space:nowrap}
.bo .bo-pill.is-warn{background:#FDF1DE;color:#8A5A12}
.bo .bo-pattern{margin:0 0 10px;font-size:12.5px;line-height:1.5}
.bo .bo-lots{display:grid;gap:5px}
.bo .bo-lot{position:relative;display:flex;align-items:center;gap:8px;height:24px;padding:0 8px;border-radius:6px;font-size:11px;color:var(--mut);overflow:hidden}
.bo .bo-lot i{position:absolute;left:0;top:0;bottom:0;background:#ECEBF7;border-radius:6px;transform-origin:left;animation:bo-grow-x .6s cubic-bezier(.215,.61,.355,1) both}
.bo .bo-lot.is-hot i{background:#FDE7C4}
.bo .bo-lot.is-hot{color:#8A5A12;font-weight:600}
.bo .bo-lot span,.bo .bo-lot b{position:relative}
.bo .bo-lot b{margin-left:auto;font-variant-numeric:tabular-nums}
@keyframes bo-grow-x{from{transform:scaleX(.05)}}
.bo .bo-bul-s{margin:0;font-size:11.5px;color:var(--ink)}
.bo .bo-bul-to{margin:0;font-size:12px;color:var(--mut)}
.bo .bo-best{list-style:none;margin:0;padding:0}
.bo .bo-best li{display:flex;align-items:baseline;gap:10px;padding:7px 0;border-top:1px solid #EEEDF5;font-size:12px}
.bo .bo-best li:first-child{border-top:0;padding-top:0}
.bo .bo-best li span{display:flex;flex-direction:column;font-weight:500;min-width:0}
.bo .bo-best small{font-size:10.5px;color:var(--mut);font-weight:400}
.bo .bo-best b{margin-left:auto;font-variant-numeric:tabular-nums}

@media (min-width:760px){
  .bo .bo-body{grid-template-columns:200px minmax(0,1fr);min-height:452px}
  .bo .bo-rail{flex-direction:column;gap:2px;overflow:visible;padding:14px 10px;border-bottom:0;border-right:1px solid var(--line)}
  .bo .bo-tab{grid-template-columns:24px 1fr;padding:10px 10px 11px;row-gap:1px}
  .bo .bo-tab-l{display:block;grid-column:2;font-size:11px;font-weight:500;opacity:.8}
  .bo .bo-rail-note{display:block;margin:auto 6px 0;padding-top:16px;font-size:11px;line-height:1.45;color:var(--mut)}
  .bo .bo-canvas{padding:20px 22px 22px}
  .bo .bo-grid{grid-template-columns:repeat(3,minmax(0,1fr))}
  .bo .bo-grid > *{grid-column:auto}
  .bo .bo-opt,.bo .bo-grid-owners > .ga-c,.bo .bo-grid-breaks > .ga-c,.bo .bo-grid-earns > .ga-c{display:flex;flex-direction:column}
  .bo .bo-grid-owners{grid-template-areas:"a b c" "t t s" "q q q"}
  .bo .bo-grid-asks{grid-template-areas:"t t a" "t t b" "r r r"}
  .bo .bo-grid-breaks{grid-template-areas:"a b c" "p p n"}
  .bo .bo-grid-earns{grid-template-areas:"a b c" "t t s"}
  .bo .ga-a{grid-area:a}.bo .ga-b{grid-area:b}.bo .ga-c{grid-area:c}.bo .ga-t{grid-area:t}.bo .ga-s{grid-area:s}
  .bo .ga-q{grid-area:q}.bo .ga-r{grid-area:r}.bo .ga-p{grid-area:p}.bo .ga-n{grid-area:n}
  .bo .bo-grid-asks > .ga-t,.bo .bo-grid-asks > .ga-r{order:0}
  .bo .bo-reco{flex-direction:row;align-items:center;gap:16px}
  .bo .bo-reco p{flex:1}
  .bo .bo-reco .bo-btn{align-self:center;margin:0;white-space:nowrap}
  .bo .bo-v{font-size:27px}
  .bo .bo-bars,.bo .bo-area{height:118px}
}
@media (max-width:759px){
  .bo .bo-range{display:none}
  .bo .bo-scope-k{display:none}
}
@media (prefers-reduced-motion:reduce){
  .bo .bo-view,.bo .bo-bars i,.bo .bo-lot i{animation:none}
  .bo .bo-area-line{animation:none;stroke-dashoffset:0}
}

.bo-sec .bo-sec-head{display:grid;gap:16px;margin-bottom:clamp(28px,3.2vw,44px)}
.bo-sec .bo-sec-head .t-h2{margin-top:0;max-width:22ch}
.bo-sec .bo-sec-head .t-lede{margin:0;max-width:52ch}
@media (min-width:960px){.bo-sec .bo-sec-head{grid-template-columns:minmax(0,1.5fr) minmax(0,1fr);gap:48px;align-items:end}}
.bo-sec .bo-sec-foot{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:12px 24px;margin-top:20px}
.bo-sec .bo-sec-foot p{margin:0;font-size:13px;color:#67648F;max-width:60ch}
`;
